import React from 'react';
import styled from 'styled-components';

import { scrollbarStyle } from 'styleShared';

import MarketHeaderStats from './MarketHeaderStats';
import MarketHeaderTitle from './MarketHeaderTitle';
import MarketsTickersScreen from './marketsScreen/MarketsTickersScreen';

const Wrapper = styled.div`
  min-height: 43px;
  padding: 0 4px;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  overflow-x: auto;
  ${scrollbarStyle}

  background: var(--elevation-light);
  border-radius: 2px;
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
`;

function MarketHeader() {
  return (
    <Wrapper>
      <TitleWrap>
        <MarketHeaderTitle />
      </TitleWrap>
      <MarketHeaderStats />
      <MarketsTickersScreen />
    </Wrapper>
  );
}

export default MarketHeader;
